module.exports = "https://cdn.redage.net/src/views/player/help/images/pd2.jpg";